import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Pill: FunctionComponent<Props> = ({ children, className = '', testId = TEST_ID, title }) => (
    <span className={`${styles.pill} ${className}`} data-testid={testId} title={title}>
        {children}
    </span>
);

export default Pill;
